export default __webpack_public_path__ + "assets/hnEditionLogo.fd23c8.png";